import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    image = "image",
    description = "description",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.description]: string;
    };
}

export interface CENLeadImageTextStyles {
    container?: GridContainerProps;
    imageGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    description?: InjectableCss;
    quoteImage?: InjectableCss;
}

export const CENleadImageTextStyles: CENLeadImageTextStyles = {
    container: {
        css: css`
            margin-top: 48px;
        `,
    },
    imageGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            padding: 0 !important;
            margin-top: 9px;
        `,
    },
    descriptionGridItem: {
        width: [12, 12, 12, 7, 7],
        css: css`
            padding-right: 24px;
            flex-direction: column;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding-right: 0px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ]);
            }}
        `,
    },
    description: {
        css: css`
            line-height: 28px !important;
            color: ${getProp("theme.typography.p.color")};
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        p {
                            font-size: ${TYPOGRAPHY.size.smaller} !important;
                            line-height: 22px !important;
                        }
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    quoteImage: {
        css: css`
            width: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        max-height: 239px;
                        height: auto;
                        object-fit: contain;
                    `,
                    null,
                    null,
                    null,
                    null,
                ]);
            }}
        `,
    },
};

const styles = CENleadImageTextStyles;

export const CENLeadImageText: FC<OwnProps> = ({ fields }) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.descriptionGridItem}>
                <Typography {...styles.description}>
                    {parse(transformContentHtml(fields.description), parserOptions)}
                </Typography>
            </GridItem>
            <GridItem {...styles.imageGridItem}>
                <Img src={fields.image} altText="fields.description" loading="lazy" {...styles.quoteImage} />
            </GridItem>
        </GridContainer>
    );
};

const LeadImageText: WidgetModule = {
    component: CENLeadImageText,
    definition: {
        group: "Common",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                name: fields.image,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Image",
            },
            {
                name: fields.description,
                displayName: "Description",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default LeadImageText;
